// Fredesigner cart rewards (card Claude-52). Since 10-27 (owner, Claude-79) any copy of this theme runs it; on the live theme only when switched on.
// 1. Cart page panel (under "10% OFF Your Order"): verify prompt, best rewards for this cart,
//    "add $X more" hint, free-shipping hint, spins left, and add-on suggestions.
// 2. Compact line in the header mini cart.
// 3. Checkout: before the theme's checkout guard runs, ask the rewards service for the best
//    codes (store/cart/apply), put them in the cart (/cart/update.js {discount}), then hand the
//    same click back to the guard, which validates and opens checkout as before. A failure or
//    a slow answer (about 8 s) never blocks checkout: the guard simply continues without codes.
// 4. Claude-54: custom-option carts check out through a VO Product Options draft order, which
//    ignores cart codes. The cart also gets the attribute _fd_rw_ref (an opaque value from
//    store/cart/apply, no personal data); VO copies it onto the draft. When VO answers the
//    guard's draft request with the invoice URL, store/cart/attach puts the codes on that draft
//    (about 5 s at most) before the guard follows the URL. Any failure: checkout goes on as is.
// 5. Claude-61 (owner 10-26): Black Friday 25% sitewide, either-or with the rewards (window in
//    FD_REWARDS_DRAFT.blackFriday). Verified: the service says which package is better
//    (blackFriday.package); with Black Friday no code goes into the cart. Others: one line from the
//    snippet's dates (client clock). The free-shipping line uses the temporary $225 in the window.
// 6. Claude-66: FD_REWARDS_DRAFT.bfMessaging (global setting "Black Friday 25% messaging", false only
//    when unticked) turns the panel's and the mini cart's Black Friday lines off; bfShip225 ("Black
//    Friday free shipping from $225") false keeps the $300 line in the window. Visitors get no
//    Black Friday line here any more: the cart page's offer card already says it (review P3-1).
// 7. Claude-71 (referral program; route contract v1 of Claude-70, C:/fdw/p170-docs): a page with
//    ?fdr=<alias> calls store/ref/open (no card session). The signed token goes into the first-party
//    cookie fd_ref (30 days; a later click overwrites an earlier one) and the cart attribute _fd_ref
//    (again on later page views, after cart changes and before checkout, in case a new cart was made).
//    A friend without a card session also gets the referrer's extra code in the cart, never during
//    Black Friday; with a session, store/cart/apply chooses it with the rewards (referralToken).
//    A failed or slow open (Render cold start) keeps only the alias and tries again on the next page.
//    Claude-83: ?fdr leaves the address bar once read; a pending alias gets at most 3 opens within 24 hours.
//    VO drafts: store/ref/attach (no session) or store/cart/attach (session) writes the code in the
//    single draft update. Product-page dynamic checkout buttons are hidden while a referral is held.
// Codes exist only in memory and in the /cart/update.js body: never in storage, logs or URLs.
// Every text is set with textContent; no service or product text is parsed as HTML.
(()=>{
 'use strict';
 // Claude-83: theme ids gate nothing here (Claude-79, owner 10-27); this old list only feeds the test hook.
 const THEME_IDS=Object.freeze(['186767376634','187593687290','187639398650']);// no longer a gate (theme-id gate removed 10-27 (owner): any copy of this theme behaves like live); kept for the test hook only
 const TOKEN_KEY='fd_rewards_store_token_v1',SUMMARY_KEY='fd_rewards_summary_v1';
 const TOKEN_RE=/^[A-Za-z0-9_-]{20,128}$/,CODE_RE=/^FDR-[0-9A-HJKMNP-TV-Z]{4}-[0-9A-HJKMNP-TV-Z]{4}-[0-9A-HJKMNP-TV-Z]{4}-[0-9A-HJKMNP-TV-Z]{4}$/;
 // Review Claude-53 P3-1: the whole checkout step (cart read + apply + cart update) shares one
 // budget of about 8 s; anything left over when it runs out is skipped and checkout goes on.
 const APPLY_BUDGET_MS=8000,CART_TIMEOUT_MS=8000,PREVIEW_MAX_AGE_MS=60000,ENABLE_WAIT_MS=3000;
 // Review Claude-53 P3-4: at most one preview request per 5 s (same or different subtotal).
 const PREVIEW_MIN_GAP_MS=5000;
 const FREE_SHIPPING_CENTS=30000,MAX_CODES=5;
 // Claude-54: the VO Product Options service the checkout guard (and VO itself) posts the cart to.
 const VO_ENDPOINT='https://obscure-escarpment-2240.herokuapp.com/add-ons',REF_ATTRIBUTE='_fd_rw_ref';
 const REF_RE=/^[A-Za-z0-9_-]{43}$/,ATTACH_BUDGET_MS=5000,VO_ARM_MS=120000,VO_WAIT_MS=10000;
 const VO_HOSTS=['www.fredesigner.com','fredesigner.com','c5e1ec-d7.myshopify.com'];
 // Seel Worry-Free Purchase is not merchandise for coupon minimums (design 三.2).
 const SEEL_PRODUCT_ID='9309433037050';
 const TEXT=Object.freeze({
  title:'Your rewards',
  // Owner 10-28: a shopper who won rewards on another device must verify here, or checkout goes without them.
  unverified:'Have rewards? Verify your email here and they are applied automatically at checkout. New here? Unlock 3 free spins (up to a $500 voucher).',
  again:'Verify your email again to apply your rewards at checkout.',
  verify:'Verify my email',
  checking:'Checking your rewards…',
  none:'No rewards apply to this cart yet',
  savings:amount=>`Rewards savings: −${amount}`,
  auto:'Applied automatically at checkout.',
  email:masked=>`Use ${masked} at checkout`,
  next:(amount,name,save)=>`Add ${amount} more to use your ${name} (save about ${save}).`,
  // Claude-61: the line is $300, or $225 during Black Friday (same words as before for $300).
  shipFree:line=>`This order qualifies for free standard shipping (from ${roughMoney(line)} after discounts).`,
  shipMore:(amount,line)=>`Free standard shipping from ${roughMoney(line)} after discounts: add ${amount} more.`,
  spins:n=>`You have ${n} free spin${n===1?'':'s'} left`,
  spin:'Spin the wheel',
  failed:'Your rewards could not be checked right now.',
  retry:'Try again',
  addOns:'Complete your order',
  choose:'Choose options',from:amount=>`From ${amount}`,
  add:'Add to cart',adding:'Adding…',addFailed:'This item could not be added. Please try again.',
  applying:'Applying your rewards…',
  tapAgain:'Please tap Checkout again.',
  voucherVerify:'To use your voucher, you will confirm your email when you check out.',
  miniAuto:'Rewards you can use are applied automatically at checkout.',
  miniSavings:amount=>`Rewards savings: −${amount}, applied automatically at checkout.`,
  // Owner 10-25: when the rewards take the order under the free-shipping line, the service's total
  // is net of the standard shipping that is then charged; show that as its own line.
  shipping:'Standard shipping',shippingAmount:amount=>`+${amount}`,
  shipRule:line=>`Free standard shipping from ${roughMoney(line)} after discounts`,
  // Claude-56: the checkout guard could not confirm the custom price, so no amount is shown.
  priceWait:'Your rewards will show once your custom price is confirmed.',
  // Claude-61 (owner 10-26): Black Friday 25% sitewide, either-or with the rewards.
  // Claude-66 (review Claude-65 P3-5): the same capitalization as the announcement bar.
  bfLine:'Black Friday: 25% Off Sitewide',
  bfApplied:"We've applied your best price — Black Friday: 25% Off Sitewide",
  bfWallet:'Your rewards stay in your wallet for later.',
  bfRewards:'Your rewards save you more than 25% — applied automatically',
  // The cart subtotal already shows the 25% price, so the rewards package states its own price.
  bfRewardsPrice:amount=>`Your price with rewards: ${amount} (before shipping and tax)`,
  miniBf:amount=>`Black Friday: 25% Off Sitewide (−${amount}), applied automatically at checkout.`,
  miniBfRewards:amount=>`Your price with rewards: ${amount}, applied automatically at checkout.`,
  // Claude-71: friend-side referral hint and the referral line among the rewards (contract 4.).
  // Owner 10-28: above 10% the friend's rate is for their first order with the link (extra code once per customer).
  refHint:(rate,name)=>rate>10?`${rate}% off your first order with ${name?name+"'s":"your friend's"} link is applied at checkout.`:`${rate}% off with ${name?name+"'s":"your friend's"} link is applied at checkout.`,
  refLine:(name,extra)=>`${name?name+"'s":"Your friend's"} link (extra ${extra}% off)`,
  // Owner test 10-27: a friend's link shows its own rate in place of the base 10% headline.
  refOffer:rate=>`${rate}% OFF Your First Order`,
  refOfferNote:name=>`With ${name?name+"'s":"your friend's"} link. Applied automatically at checkout. No code needed.`
 });
 let offerBase=null;// the theme's own headline, kept for refOffer

 // ---- Pure helpers (also used by the unit tests) ----
 const money=cents=>'$'+(Math.max(0,cents)/100).toFixed(2).replace(/\B(?=(\d{3})+\.)/g,',');
 const roughMoney=cents=>'$'+Math.max(1,Math.round(cents/100)).toLocaleString('en-US');
 const intOk=v=>Number.isSafeInteger(v)&&v>=0;
 // Claude-61: the snippet's Black Friday window [startsAt, endsAt) at nowMs; null config or bad dates: off.
 function blackFridayOn(bf,nowMs){
  if(!bf||typeof bf!=='object'||typeof bf.startsAt!=='string'||typeof bf.endsAt!=='string')return false;
  const start=Date.parse(bf.startsAt),end=Date.parse(bf.endsAt);
  return Number.isFinite(start)&&Number.isFinite(end)&&Number.isFinite(nowMs)&&nowMs>=start&&nowMs<end;
 }
 // The free-shipping line when the service did not send one: the snippet's Black Friday line in the window.
 // Claude-66: `ship225` false (theme setting off): always the standing $300.
 function shippingLineOf(bf,nowMs,ship225=true){
  const line=bf&&bf.freeShippingThresholdCents;
  return ship225!==false&&blackFridayOn(bf,nowMs)&&Number.isSafeInteger(line)&&line>0?line:FREE_SHIPPING_CENTS;
 }
 // Claude-66: the two theme settings from FD_REWARDS_DRAFT; unset (older snippet) counts as on.
 function bfFlags(c){
  const messaging=!!c&&typeof c==='object'&&c.bfMessaging!==false;
  return {messaging,ship225:messaging&&c.bfShip225!==false};
 }
 // The panel's free-shipping line: the service's when the $225 setting is on, else $300.
 function panelShippingLine(served,bf,nowMs,flags){
  if(!flags||flags.ship225!==true)return FREE_SHIPPING_CENTS;
  const line=served&&served.freeShippingThresholdCents;
  return Number.isSafeInteger(line)&&line>0?line:shippingLineOf(bf,nowMs);
 }
 const isSeel=item=>String(item?.product_id)===SEEL_PRODUCT_ID||/^seel-wfp$/i.test(String(item?.product_type||''))||/^seel$/i.test(String(item?.vendor||''));
 // Merchandise before discounts in cents: /cart.js original_total_price without Seel lines, plus
 // the custom-option add-ons the checkout guard has confirmed for this cart (BCPO lines carry only
 // their base price in /cart.js; the add-ons are charged at checkout).
 function subtotalOf(cart,addOnCents=0){
  if(!cart||!intOk(cart.original_total_price))return null;
  let cents=cart.original_total_price;
  for(const item of Array.isArray(cart.items)?cart.items:[])if(isSeel(item)){
   const line=Number(item.original_line_price??item.line_price);
   if(intOk(line))cents-=line;
  }
  return Math.max(0,cents+(intOk(addOnCents)?addOnCents:0));
 }
 // C96 (review Claude-95 P1-1): the merchandise discount rate /cart.js shows on the base prices
 // (Seel lines out). Cart-level discounts (the automatic 10% / 25% order offer) are spread over the
 // lines in proportion, as checkout does; line-level ones are already in final_line_price. 0..1.
 function discountRateOf(cart){
  const items=Array.isArray(cart?.items)?cart.items:[];
  let all=0,merchFinal=0,merchOriginal=0;
  for(const item of items){
   const fin=Number(item.final_line_price),orig=Number(item.original_line_price??item.line_price);
   if(!intOk(fin))continue;
   all+=fin;
   if(!isSeel(item)){merchFinal+=fin;merchOriginal+=intOk(orig)?orig:fin;}
  }
  if(merchOriginal<=0||!intOk(cart?.total_price))return 0;
  const cartLevel=Math.max(0,all-cart.total_price),merchAfter=merchFinal-(all>0?cartLevel*merchFinal/all:0);
  return Math.min(1,Math.max(0,1-merchAfter/merchOriginal));
 }
 // What the order costs after discounts (for the $300 / $225 free-shipping line). C96: checkout takes
 // the same discount off the option add-ons as off the base price (BCPO lines carry only their base in
 // /cart.js), so: merchandise before discounts (Seel out) plus confirmed add-ons, less that rate (at
 // least floorPercent: Black Friday 25%, or the friend's referral rate in place of the 10%), minus the
 // rewards the service expects to apply. Rounded down, so it never says free shipping too early.
 // No merchandise and no add-ons (empty cart, or only Seel): null, no shipping line.
 function afterDiscountsOf(cart,addOnCents=0,rewardCents=0,floorPercent=0){
  if(!cart||!intOk(cart.total_price))return null;
  const base=subtotalOf(cart,0),add=intOk(addOnCents)?addOnCents:0;
  if(base===null||base+add<=0)return null;
  const floor=Number.isFinite(floorPercent)&&floorPercent>0&&floorPercent<100?floorPercent/100:0;
  const rate=Math.max(discountRateOf(cart),floor);
  const cents=Math.floor((base+add)*(1-rate)+1e-6)-(intOk(rewardCents)?rewardCents:0);
  return Math.max(0,cents);
 }
 // C96: the smallest discount checkout will take off this cart: Black Friday's percent in its window
 // (it replaces the 10%), otherwise the friend's referral rate when the cart hint says it applies.
 function floorPercentOf(cart,bf,nowMs,info){
  if(blackFridayOn(bf,nowMs))return Number.isInteger(bf.percent)&&bf.percent>0&&bf.percent<100?bf.percent:0;
  return info&&Number.isInteger(info.ratePercent)&&refHint(info,{cart})?info.ratePercent:0;
 }
 // Cart codes after checkout: the service's FDR codes first, then the customer's other codes
 // (kept), never more than 5. FDR codes not in the new list are dropped (the service returned them).
 // Owner 10-25: the standard shipping the rewards cost (lines minus the service's net total), else 0.
 function shippingAddedCents(items,totalSavingCents){
  if(!Array.isArray(items)||!intOk(totalSavingCents))return 0;
  let sum=0;for(const i of items){if(!intOk(i?.savingCents))return 0;sum+=i.savingCents;}
  return Math.max(0,sum-totalSavingCents);
 }
 function mergeCodes(existing,fresh){
  const out=[],seen=new Set();
  const push=code=>{const key=code.toUpperCase();if(!seen.has(key)&&out.length<MAX_CODES){seen.add(key);out.push(code);}};
  for(const code of fresh)if(typeof code==='string'&&CODE_RE.test(code))push(code);
  // Claude-71: the friend's referral extra code when store/cart/apply chose it; a referral code the
  // service left out (for example under the order's discount cap) does not stay in the cart either.
  for(const code of fresh)if(isRefCode(code)&&!CODE_RE.test(code))push(code);
  for(const code of refKnownCodes)if(!fresh.some(f=>String(f).toUpperCase()===String(code).toUpperCase()))seen.add(String(code).toUpperCase());
  for(const code of existing)if(typeof code==='string'&&code.trim()&&!/^FDR-/i.test(code.trim()))push(code.trim());
  return out;
 }
 const sameCodes=(a,b)=>a.length===b.length&&a.every((c,i)=>c.toUpperCase()===String(b[i]).toUpperCase());
 // Add-on choice: products at or just above the gap first (closest first), at most
 // gap x2 + $50; if fewer than 2, the closest ones below the gap fill up to 2. At most 4.
 function pickAddOns(list,gap,inCart=new Set()){
  if(!intOk(gap)||gap<=0)return [];
  const ok=list.filter(p=>p&&p.addable===true&&p.available===true&&intOk(p.price)&&p.price>0&&!inCart.has(String(p.variantId)));
  const cap=gap*2+5000;
  const above=ok.filter(p=>p.price>=gap&&p.price<=cap).sort((a,b)=>a.price-b.price);
  const below=ok.filter(p=>p.price<gap).sort((a,b)=>b.price-a.price);
  const out=above.slice(0,4);
  for(const p of below){if(out.length>=2)break;out.push(p);}
  return out;
 }
 const lowerFirst=name=>/^[A-Z][a-z]/.test(name)?name[0].toLowerCase()+name.slice(1):name;
 function safePath(url){
  if(typeof url!=='string'||!url.startsWith('/')||url.startsWith('//'))return null;
  try{const u=new URL(url,location.origin);return u.origin===location.origin?u.pathname+u.search:null;}catch(e){return null;}
 }
 function safeImage(src){
  if(typeof src!=='string'||!src)return null;
  try{const u=new URL(src,location.href);
   if(u.protocol!=='https:'&&u.protocol!==location.protocol)return null;
   if(u.host===location.host&&u.pathname.startsWith('/cdn/shop/'))return u.href;
   if(u.host==='cdn.shopify.com'&&u.pathname.startsWith('/s/files/'))return u.href;
   if(/\.myshopify\.com$|(^|\.)fredesigner\.com$/.test(u.hostname)&&u.pathname.startsWith('/cdn/shop/'))return u.href;
  }catch(e){}
  return null;
 }
 function parseAddOns(html){
  try{
   const doc=new DOMParser().parseFromString(String(html||''),'text/html');
   const data=JSON.parse(doc.querySelector('script[data-fd-rw-addons]')?.textContent||'null');
   if(!data||data.v!==1||!Array.isArray(data.products))return [];
   return data.products.slice(0,24).filter(p=>p&&intOk(p.id)&&intOk(p.variantId)&&typeof p.title==='string').map(p=>({
    id:p.id,variantId:p.variantId,title:p.title.slice(0,200),url:safePath(p.url),price:intOk(p.price)?p.price:0,
    available:p.available===true,addable:p.addable===true,image:safeImage(p.image)}));
  }catch(e){return [];}
 }
 // Plan A (owner 10-23): link items = Shopify recommendations (products.json) that open the product
 // page to choose options. No BCPO check needed (nothing is added from here). Starting price
 // (price_min) close to the gap: at or just above first (<= gap x2 + $50), then down to half the gap.
 const sized=src=>{const raw=typeof src==='string'?src:src&&typeof src==='object'?(src.src||src.url):'';
  if(typeof raw!=='string'||!raw)return null;
  try{const u=new URL(raw,location.href);if(!u.searchParams.has('width'))u.searchParams.set('width','160');return u.href;}catch(e){return null;}};
 function parseLinks(data){
  if(!data||!Array.isArray(data.products))return [];
  return data.products.slice(0,20).map(p=>{
   if(!p||!intOk(p.id)||typeof p.title!=='string')return null;
   const from=intOk(p.price_min)?p.price_min:intOk(p.price)?p.price:null;
   const url=safePath(p.url)||(typeof p.handle==='string'&&/^[a-z0-9][a-z0-9-]*$/i.test(p.handle)?'/products/'+p.handle:null);
   const excluded=String(p.id)===SEEL_PRODUCT_ID||/^seel/i.test(String(p.type||''))||/^seel$/i.test(String(p.vendor||''))||p.gift_card===true;
   return url&&from!==null&&from>0&&p.available===true&&!excluded?{id:p.id,title:p.title.slice(0,200),url,from,image:safeImage(sized(p.featured_image))}:null;
  }).filter(Boolean);
 }
 function pickLinks(list,gap,exclude=new Set()){
  if(!intOk(gap)||gap<=0)return [];
  const ok=list.filter(p=>!exclude.has(String(p.id)));
  const cap=gap*2+5000,floor=Math.floor(gap/2);
  const above=ok.filter(p=>p.from>=gap&&p.from<=cap).sort((a,b)=>a.from-b.from);
  const below=ok.filter(p=>p.from<gap&&p.from>=floor).sort((a,b)=>b.from-a.from);
  const out=above.slice(0,4);
  for(const p of below){if(out.length>=2)break;out.push(p);}
  return out;
 }
 // Claude-54: the draft's invoice token from VO's answer (a plain URL, as the guard reads it:
 // text, JSON text, or {checkout_url|checkoutUrl|url}). Only this shop's invoice or draft
 // checkout path on the shop's own hosts; anything else is null.
 function invoiceTokenOf(response){
  let value=response;
  if(typeof value==='string'){const text=value.trim();try{const parsed=JSON.parse(text);value=typeof parsed==='string'?parsed.trim():parsed&&typeof parsed==='object'?parsed:text;}catch(e){value=text;}}
  if(value&&typeof value==='object')value=value.checkout_url||value.checkoutUrl||value.url||'';
  if(typeof value!=='string'||!value||value.length>2048)return null;
  let url;try{url=new URL(value,location.origin);}catch(e){return null;}
  if(url.protocol!=='https:'||url.username||url.password||url.port||!VO_HOSTS.includes(url.hostname.toLowerCase()))return null;
  const path=url.pathname.replace(/\/+/g,'/');
  const m=path.match(/^\/70861750522\/invoices\/([A-Za-z0-9]{16,64})\/?$/)||path.match(/^\/checkouts\/do\/([A-Za-z0-9]{16,64})(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/?$/i);
  return m?m[1]:null;
 }
 // Claude-54: wraps jQuery's ajax (VO's bcpo.$; $.post goes through $.ajax too) for one VO
 // draft request while armed. Every other request, and every request while not armed, is the
 // original call untouched. The armed one: the original request runs; when it succeeds, attach()
 // gets the invoice token (cut after ATTACH_BUDGET_MS + 0.5 s whatever it does), then the caller's done callbacks run with
 // the original arguments. A failed request is passed on at once. attach() never throws.
 function wrapVoAjax($,{take,attach}){
  if(!$||typeof $.ajax!=='function'||typeof $.Deferred!=='function')return false;
  if($.ajax.__fdRwVo)return true;
  const original=$.ajax;
  const wrapped=function(first,second){
   const o=first&&typeof first==='object'?first:second&&typeof second==='object'?second:{};
   const target=typeof first==='string'?first:o.url;
   const method=String(o.method||o.type||'GET').toUpperCase();
   if(target!==VO_ENDPOINT||method!=='POST'||['success','error','complete'].some(k=>typeof o[k]==='function'))return original.apply(this,arguments);
   const arm=take();
   if(!arm)return original.apply(this,arguments);
   const request=original.apply(this,arguments);
   if(!request||typeof request.done!=='function'||typeof request.fail!=='function')return request;
   const deferred=$.Deferred();
   request.done(function(){
    const self=this,args=arguments;
    timeout(Promise.resolve().then(()=>attach(arm.ref,invoiceTokenOf(args[0]))),ATTACH_BUDGET_MS+500).catch(()=>{}).then(()=>deferred.resolveWith(self,args));
   });
   request.fail(function(){deferred.rejectWith(this,arguments);});
   const promise=deferred.promise();
   if(typeof request.abort==='function')promise.abort=function(){request.abort.apply(request,arguments);return promise;};
   return promise;
  };
  wrapped.__fdRwVo=true;
  $.ajax=wrapped;
  return true;
 }
 // Review Claude-55 P2-1: the checkout guard keeps an unconfirmed custom checkout in
 // sessionStorage 'fd-custom-checkout-pending-v2' (and marks a sent VO request in this page with
 // data-fd-bcpo-checkout-attempt). It can only recover that checkout while the cart signature,
 // cart attributes included, is unchanged. While either is present this module stays out of the
 // way: no apply, no cart change, no attach; the guard handles the click exactly as without it.
 const GUARD_PENDING_KEY='fd-custom-checkout-pending-v2';
 function guardCheckoutPending(getStorage,root){
  try{if(root?.dataset?.fdBcpoCheckoutAttempt==='1')return true;}catch(e){}
  try{const raw=getStorage()?.getItem(GUARD_PENDING_KEY);return typeof raw==='string'&&raw.length>0;}catch(e){return false;}
 }
 // ---- Claude-71: referral helpers (pure; the unit tests use them) ----
 const REF_COOKIE='fd_ref',REF_CART_ATTRIBUTE='_fd_ref',REF_INFO_KEY='fd_ref_info_v1',REF_PENDING_KEY='fd_ref_pending_v1';
 // Token v1.<alias>.<issuedAtSec>.<flags>.<mac> (Claude-69 src/referral-token.mjs), at most 160 characters.
 const REF_TOKEN_RE=/^v1\.[a-z0-9](?:[a-z0-9-]{0,62}[a-z0-9])\.(?:0|[1-9][0-9]{0,11})\.[01]\.[A-Za-z0-9_-]{43}$/;
 const REF_ALIAS_RE=/^[a-z0-9](?:[a-z0-9-]{0,48}[a-z0-9])?$/,REF_CODE_RE=/^[A-Z0-9](?:[A-Z0-9-]{0,62}[A-Z0-9])$/i;
 const REF_MAX_AGE_S=30*86400,REF_OPEN_TIMEOUT_MS=20000,REF_ATTACH_TIMEOUT_MS=5000;
 const REF_OPEN_PATH='/apps/fd-rewards/store/ref/open',REF_ATTACH_PATH='/apps/fd-rewards/store/ref/attach';
 // The referral codes this browser was given (current and replaced ones); mergeCodes drops any of
 // them that store/cart/apply did not return. Set before a checkout; empty otherwise.
 let refKnownCodes=[];
 const refTokenOk=t=>typeof t==='string'&&t.length<=160&&REF_TOKEN_RE.test(t);
 const refAliasOfToken=t=>refTokenOk(t)?t.split('.')[1]:null;
 const isRefCode=c=>typeof c==='string'&&c.length<=64&&REF_CODE_RE.test(c)&&!/^FDR-/i.test(c);
 // ?fdr=<alias>: null without the parameter, '' when the value is not an alias (ignored), else lower case.
 function refAliasOf(search){
  try{const v=new URLSearchParams(String(search||'')).get('fdr');if(v===null)return null;const a=v.trim().toLowerCase();return REF_ALIAS_RE.test(a)?a:'';}catch(e){return null;}
 }
 function readRefCookie(cookie){
  const m=/(?:^|;\s*)fd_ref=([^;]*)/.exec(String(cookie||''));if(!m)return null;
  let v;try{v=decodeURIComponent(m[1]);}catch(e){return null;}
  return refTokenOk(v)?v:null;
 }
 // First-party, 30 days, the whole store, Lax; Secure on https.
 const refCookieString=(token,secure)=>`${REF_COOKIE}=${token}; Max-Age=${REF_MAX_AGE_S}; Path=/; SameSite=Lax${secure?'; Secure':''}`;
 // store/ref/open answers (contract 2.1 and the shared error table) as one of:
 // ready {token, info} | unknown (store nothing) | off (feature off: no retry) | drop (refused: no retry) |
 // retry (429, 503, timeout, cold start: keep the alias, try again on the next page view).
 function parseRefOpen(status,body){
  const b=body&&typeof body==='object'&&!Array.isArray(body)?body:null;
  if(status===200&&b?.schemaVersion===1&&b.status==='unknown')return {kind:'unknown'};
  if(status===200&&b?.schemaVersion===1&&b.status==='ready'){
   const ok=typeof b.alias==='string'&&REF_ALIAS_RE.test(b.alias)&&refTokenOk(b.token)&&refAliasOfToken(b.token)===b.alias&&
    Number.isInteger(b.ratePercent)&&b.ratePercent>=10&&b.ratePercent<=15&&(b.extraCode===null||isRefCode(b.extraCode));
   if(!ok)return {kind:'drop'};
   const name=typeof b.displayName==='string'&&b.displayName.trim()&&b.displayName.length<=80?b.displayName.trim():'';
   return {kind:'ready',token:b.token,info:{v:1,alias:b.alias,displayName:name,ratePercent:b.ratePercent,
    extraCode:b.extraCode,blackFridayActive:b.blackFridayActive===true}};
  }
  if(status===404&&b?.error==='NOT_FOUND')return {kind:'off'};
  if(status===0||status===429||status>=500||(status===404&&!b)||(status===200&&!b))return {kind:'retry'};
  return {kind:'drop'};
 }
 // The cart codes with the referral code added (when given) and replaced referral codes taken out.
 function refCodesFor(existing,add,drop=[]){
  const out=[],seen=new Set(),keep=String(add||'').toUpperCase(),gone=new Set(drop.filter(isRefCode).map(c=>c.toUpperCase()));
  for(const raw of existing){const c=String(raw||'').trim(),k=c.toUpperCase();if(!c||seen.has(k)||(gone.has(k)&&k!==keep))continue;seen.add(k);out.push(c);}
  if(isRefCode(add)&&!seen.has(keep)&&out.length<MAX_CODES)out.push(add);
  return out;
 }
 // /cart/update.js body that puts the referral into this cart, or null when it is already there.
 // withCode: the friend's extra code goes in too (no card session, outside Black Friday).
 function refCartPatch(cart,{token,info=null,withCode=false}={}){
  if(!cart||!refTokenOk(token))return null;
  const body={};
  if(cart.attributes?.[REF_CART_ATTRIBUTE]!==token)body.attributes={[REF_CART_ATTRIBUTE]:token};
  if(withCode){
   const existing=(Array.isArray(cart.discount_codes)?cart.discount_codes:[]).map(d=>String(d?.code||'').trim()).filter(Boolean);
   const next=refCodesFor(existing,info?.extraCode||null,Array.isArray(info?.dropCodes)?info.dropCodes:[]);
   if(!sameCodes(next,existing))body.discount=next.join(',');
  }
  return Object.keys(body).length?body:null;
 }
 // Friend-side hint in the cart panel ("13% off with Jack's link is applied at checkout."), or ''.
 // No session: outside Black Friday only (the 25% always saves more than 10–15%), and not when the cart
 // says the extra code cannot be used. Session: only when store/cart/preview says the referral package wins.
 function refHint(info,{session=false,preview=null,cart=null,inBfWindow=false}={}){
  const name=typeof info?.displayName==='string'?info.displayName:'';
  if(session){
   const r=preview?.referral;
   if(!r||r.active!==true||r.package?.winner!=='referral'||!Number.isInteger(r.ratePercent))return '';
   if(r.ratePercent>10&&r.package.extraApplied!==true)return '';
   return TEXT.refHint(r.ratePercent,name);
  }
  if(!info||!Number.isInteger(info.ratePercent)||inBfWindow)return '';
  if(info.ratePercent>10){
   if(!info.extraCode)return '';
   const entry=(Array.isArray(cart?.discount_codes)?cart.discount_codes:[]).find(d=>String(d?.code||'').toUpperCase()===info.extraCode.toUpperCase());
   if(entry&&entry.applicable===false)return '';
  }
  return TEXT.refHint(info.ratePercent,name);
 }
 if(window.__FD_RW_CART_TEST__===true)window.__fdRwCartTest={money,roughMoney,subtotalOf,afterDiscountsOf,discountRateOf,floorPercentOf,mergeCodes,pickAddOns,pickLinks,parseLinks,lowerFirst,safePath,safeImage,parseAddOns,TEXT,
  invoiceTokenOf,wrapVoAjax,VO_ENDPOINT,REF_ATTRIBUTE,guardCheckoutPending,GUARD_PENDING_KEY,shippingAddedCents,
  blackFridayOn,shippingLineOf,bfFlags,panelShippingLine,THEME_IDS};
 if(window.__FD_RW_CART_TEST__===true)Object.assign(window.__fdRwCartTest,{refAliasOf,readRefCookie,refCookieString,parseRefOpen,refCodesFor,
  refCartPatch,refHint,refTokenOk,isRefCode,setRefKnownCodes(v){refKnownCodes=Array.isArray(v)?v:[];},REF_COOKIE,REF_CART_ATTRIBUTE});

 // ---- Same guards as the launcher: any copy of this theme; on the live theme only when switched on ----
 const cfg=window.FD_REWARDS_DRAFT;
 if(!cfg||/* theme-id gate removed 10-27 (owner): any copy of this theme behaves like live */
  (window.Shopify?.theme?.role==='main'&&cfg.publicOn!==true))return;
 const designMode=!!window.Shopify?.designMode;
 const flags=bfFlags(cfg);

 const store=(area,key)=>{try{return window[area].getItem(key);}catch(e){return null;}};
 const readJson=key=>{try{return JSON.parse(store('localStorage',key)||'null');}catch(e){return null;}};
 const hasToken=()=>{const t=readJson(TOKEN_KEY);return !!t&&typeof t.token==='string'&&TOKEN_RE.test(t.token);};
 const hasSummary=()=>{const s=readJson(SUMMARY_KEY);return !!s&&s.v===1&&Number.isInteger(s.freeSpins);};
 const root=()=>{const r=window.Shopify?.routes?.root;return typeof r==='string'&&/^\/(?!\/)[\w\-\/]*$/.test(r)?r.replace(/\/?$/,'/'):'/';};
 const sleep=ms=>new Promise(resolve=>setTimeout(resolve,ms));
 function timeout(promise,ms){
  let timer;
  return Promise.race([promise,new Promise((_,reject)=>{timer=setTimeout(()=>reject(Object.assign(Error('TIMEOUT'),{kind:'TIMEOUT'})),ms);})]).finally(()=>clearTimeout(timer));
 }
 async function cartRequest(path,{method='GET',body,timeoutMs=CART_TIMEOUT_MS}={}){
  const controller=typeof AbortController==='function'?new AbortController():null;
  const timer=controller?setTimeout(()=>controller.abort(),Math.max(1,timeoutMs)):null;
  try{
   const init={method,cache:'no-store',credentials:'same-origin',headers:{Accept:'application/json'},signal:controller?.signal};
   if(body){init.headers['Content-Type']='application/json';init.body=JSON.stringify(body);}
   const response=await fetch(root()+path,init);
   if(!response.ok)return null;
   return await response.json();
  }catch(e){return null;}
  finally{if(timer)clearTimeout(timer);}
 }
 const getCart=(opts)=>cartRequest('cart.js',opts);
 // Add-ons confirmed by the checkout guard for the current cart (0 when not confirmed).
 function confirmedAddOns(){
  const d=document.documentElement.dataset;
  const cents=Number(d.fdConfiguredCartAddOnCents);
  return d.fdConfiguredCartValid==='true'&&intOk(cents)?cents:0;
 }
 // Claude-56 (owner 10-26): amounts wait for the guard. Until it has confirmed this cart, a custom
 // line counts only its base price (the panel showed −$3.75 first, then −$17.50).
 // 'ready', 'invalid' (the guard could not confirm the custom price) or 'loading'.
 function priceState(){
  const page=document.querySelector('[data-fd-cart-page][data-fd-price-state-guard]');
  const valid=document.documentElement.dataset.fdConfiguredCartValid==='true';
  if(!page)return valid?'ready':'loading';
  const phase=page.dataset.fdPriceState;
  return phase==='ready'&&valid?'ready':phase==='invalid'?'invalid':'loading';
 }
 let popup=null;
 function loadPopup(){
  const url=document.getElementById('fd-rewards-entry')?.dataset.popup;
  if(!url)return Promise.reject(Error('NO_CARD'));
  if(!popup)popup=import(url).catch(e=>{popup=null;throw e;});
  return popup;
 }
 // Opens the rewards card (launcher event). Returns false when the card cannot open now.
 function openCard(view,from){
  const detail={view,from,accepted:false};
  try{document.dispatchEvent(new CustomEvent('fd-rewards:open',{detail}));}catch(e){}
  return detail.accepted;
 }
 const el=(tag,cls,text)=>{const n=document.createElement(tag);if(cls)n.className=cls;if(text!==undefined)n.textContent=text;return n;};
 const button=(cls,text,onClick)=>{const b=el('button',cls,text);b.type='button';b.addEventListener('click',onClick);return b;};

 // ---- Rewards preview (shared by the panel and the mini cart) ----
 let preview={key:'',at:0,state:'idle',data:null,run:null},lastPreviewAt=0,rateUntil=0;
 async function getPreview(subtotal,{force=false}={}){
  const key=String(subtotal);
  if(!force&&preview.key===key&&preview.state==='ready'&&Date.now()-preview.at<PREVIEW_MAX_AGE_MS)return preview;
  if(preview.run&&preview.key===key)return preview.run;
  // Same subtotal answered (even with an error) less than 5 s ago: reuse that answer.
  if(!force&&preview.key===key&&preview.state!=='loading'&&preview.state!=='idle'&&Date.now()-preview.at<PREVIEW_MIN_GAP_MS)return preview;
  // Contract 1.2 (429): no new request before retryAfter has passed; what is shown stays.
  if(Date.now()<rateUntil&&preview.state!=='loading'&&preview.state!=='idle')return preview;
  const prev=preview;
  preview={key,at:0,state:'loading',data:null,run:null};
  const mine=preview;
  mine.run=(async()=>{
   // A different subtotal right after the last request waits for the 5 s gap; if the cart
   // changes again meanwhile, only the newest subtotal is asked for.
   const wait=lastPreviewAt+PREVIEW_MIN_GAP_MS-Date.now();
   if(wait>0)await sleep(wait);
   if(preview!==mine){mine.run=null;return preview.run||preview;}
   lastPreviewAt=Date.now();
   try{const m=await loadPopup();const data=await m.cartPreview(subtotal);if(preview===mine)Object.assign(mine,{state:'ready',data,at:Date.now()});}
   catch(e){
    if(preview!==mine){}
    else if(e?.kind==='RATE'){
     // Rate limited is not signed out: keep the last answer for this subtotal on screen (or
     // "Checking your rewards…") and ask again after retryAfter seconds.
     const ms=Math.max((e.retryAfter||1)*1000,PREVIEW_MIN_GAP_MS);rateUntil=Date.now()+ms;
     if(prev.key===key&&prev.data)Object.assign(mine,{state:'ready',data:prev.data,at:prev.at});
     else Object.assign(mine,{state:'rate',at:Date.now()});
     setTimeout(()=>{if(lastCart)soon(lastCart,0);},ms+50);
    }
    else Object.assign(mine,{state:e?.kind==='REAUTH'&&e.reason!=='recent_verification'?'signedOut':'failed',at:Date.now()});
   }
   finally{mine.run=null;}
   return mine;
  })();
  return mine.run;
 }
 const nameOf=(m,type)=>(m&&typeof m.walletName==='function'&&m.walletName(type))||type;

 // ---- Cart page panel ----
 const panel=document.querySelector('[data-fd-rw-cart]');
 let lastCart=null,renderSeq=0,addOnRun=null,linkRun=null,linkKey='',busyAdding=false;
 // One-click items: only the cart-add-ons collection (plan A), with the guard-compatible
 // "addable" flag from sections/fd-rw-cart-addons.liquid. No collection: no one-click items.
 function addOns(){
  if(!addOnRun)addOnRun=(async()=>{
   try{const r=await fetch(root()+'collections/cart-add-ons?section_id=fd-rw-cart-addons',{cache:'no-store',credentials:'same-origin',headers:{Accept:'text/html'}});
    return r.ok?parseAddOns(await r.text()):[];}catch(e){return [];}
  })();
  return addOnRun;
 }
 // Link items: related products of the first cart product (not Seel), then complementary when
 // related has nothing usable. Cached per product for this page view.
 function links(cart){
  const inCart=new Set((cart?.items||[]).map(i=>String(i.product_id)));
  const first=(cart?.items||[]).find(i=>!isSeel(i))?.product_id;
  if(!intOk(first))return Promise.resolve([]);
  if(linkRun&&linkKey===String(first))return linkRun;
  linkKey=String(first);
  linkRun=(async()=>{
   for(const intent of ['related','complementary']){
    const data=await cartRequest(`recommendations/products.json?product_id=${first}&limit=10&intent=${intent}`);
    const list=parseLinks(data).filter(p=>!inCart.has(String(p.id)));
    if(list.length)return list;
   }
   return [];
  })();
  return linkRun;
 }
 async function addToCart(product,control,note){
  if(busyAdding||flight)return;
  busyAdding=true;control.disabled=true;control.textContent=TEXT.adding;note.textContent='';
  const added=await cartRequest('cart/add.js',{method:'POST',body:{items:[{id:product.variantId,quantity:1}]}});
  if(added){
   // A full reload: the cart lines, prices and the checkout guard's evidence all come from the server.
   location.reload();return;
  }
  busyAdding=false;control.disabled=false;control.textContent=TEXT.add;note.textContent=TEXT.addFailed;
 }
 function renderAddOns(target,list,linkList,gap,cart){
  const inCart=new Set((cart?.items||[]).map(i=>String(i.variant_id)));
  const picks=pickAddOns(list,gap,inCart);
  const shown=new Set([...picks.map(p=>String(p.id)),...(cart?.items||[]).map(i=>String(i.product_id))]);
  const linkPicks=pickLinks(linkList,gap,shown);
  if(!picks.length&&!linkPicks.length)return;
  const box=el('div','fd-rw-cart__addons');
  const heading=el('p','fd-rw-cart__addons-title',TEXT.addOns);heading.id='fd-rw-cart-addons-title';
  const ul=el('ul','fd-rw-cart__addon-list');ul.setAttribute('aria-labelledby',heading.id);
  for(const p of picks){
   const li=el('li','fd-rw-cart__addon');
   if(p.image){const img=el('img');img.src=p.image;img.alt='';img.width=56;img.height=56;img.loading='lazy';li.append(img);}
   const info=el('div','fd-rw-cart__addon-info');
   if(p.url){const a=el('a','fd-rw-cart__addon-name',p.title);a.href=p.url;info.append(a);}else info.append(el('span','fd-rw-cart__addon-name',p.title));
   info.append(el('span','fd-rw-cart__addon-price',money(p.price)));
   const note=el('span','fd-rw-cart__addon-note');note.setAttribute('role','status');
   const add=button('fd-rw-cart__addon-add',TEXT.add,()=>addToCart(p,add,note));
   add.setAttribute('aria-label',`${TEXT.add}: ${p.title}`);
   info.append(add,note);li.append(info);ul.append(li);
  }
  // Link items: same row layout; "Choose options" opens the product page in this tab.
  for(const p of linkPicks){
   const li=el('li','fd-rw-cart__addon fd-rw-cart__addon--link');
   if(p.image){const img=el('img');img.src=p.image;img.alt='';img.width=56;img.height=56;img.loading='lazy';li.append(img);}
   const info=el('div','fd-rw-cart__addon-info');
   const name=el('a','fd-rw-cart__addon-name',p.title);name.href=p.url;
   const go=el('a','fd-rw-cart__addon-choose',TEXT.choose);go.href=p.url;go.setAttribute('aria-label',`${TEXT.choose}: ${p.title}`);
   info.append(name,el('span','fd-rw-cart__addon-price',TEXT.from(money(p.from))),go);li.append(info);ul.append(li);
  }
  box.append(heading,ul);target.append(box);
 }
 async function renderPanel(cart){
  if(!panel)return;
  const seq=++renderSeq;
  const usd=cart&&String(cart.currency||'USD').toUpperCase()==='USD';
  const addOnCents=confirmedAddOns();
  const subtotal=usd?subtotalOf(cart,addOnCents):null;
  const prices=usd?priceState():'ready';
  const card=el('div','fd-rw-cart__card');
  const title=el('p','fd-rw-cart__title',TEXT.title);title.id='fd-rw-cart-title';
  card.setAttribute('role','group');card.setAttribute('aria-labelledby',title.id);
  card.append(title);
  let rewardCents=0,gap=0,module=null,shippingCents=0,shippingRow=null;
  const signedIn=hasToken();
  // Owner test 10-27: the headline follows the friend's link (with a card session, until the preview decides).
  const refStart=refInfo();
  refOffer(refHint(refStart,{cart,inBfWindow:blackFridayOn(cfg.blackFriday,Date.now())})?refStart.ratePercent:null,refStart?.displayName||'');
  if(!signedIn){
   // Claude-71: the friend-side hint first (no card session: from the stored referral and this cart).
   const refNote=refHint(refInfo(),{cart,inBfWindow:blackFridayOn(cfg.blackFriday,Date.now())});if(refNote)card.append(refHintNode(refNote));
   card.append(el('p','fd-rw-cart__lead',hasSummary()?TEXT.again:TEXT.unverified));
   const b=button('fd-rw-cart__button',TEXT.verify,()=>openCard('entry',b));
   card.append(b);
  }else if(subtotal===null){
   card.append(el('p','fd-rw-cart__note',TEXT.auto));
  }else if(prices!=='ready'){
   const wait=el('p','fd-rw-cart__note',prices==='invalid'?TEXT.priceWait:TEXT.checking);wait.setAttribute('role','status');
   card.append(wait);
  }else{
   const waiting=el('p','fd-rw-cart__note',TEXT.checking);waiting.setAttribute('role','status');
   const pending=preview.key!==String(subtotal)||preview.state!=='ready';
   if(pending){card.append(waiting);mount(card);}
   const result=await getPreview(subtotal);
   if(seq!==renderSeq)return;
   if(pending)waiting.remove();
   try{module=await loadPopup();}catch(e){}
   if(result.state==='signedOut'){
    // The service ended the sign-in (the card keeps the code-free list): ask for a new code.
    card.append(el('p','fd-rw-cart__lead',TEXT.again));
    const b=button('fd-rw-cart__button',TEXT.verify,()=>openCard('entry',b));card.append(b);
   }else if(result.state==='rate'){
    card.append(el('p','fd-rw-cart__note',TEXT.checking));
   }else if(result.state!=='ready'){
    card.append(el('p','fd-rw-cart__note',TEXT.failed));
    card.append(button('fd-rw-cart__link',TEXT.retry,()=>{preview={key:'',at:0,state:'idle',data:null,run:null};void refresh();}));
   }else{
    const d=result.data;rewardCents=d.totalSavingCents;
    // Claude-71: with a card session the service chose the package (referral.package); the hint and the
    // referral line show only when the referral package wins (in Black Friday too).
    const refNow=refInfo(),refNote=refHint(refNow,{session:true,preview:d}),pk=d.referral?.package;
    const refSave=refNote&&pk?.extraApplied===true&&Number.isSafeInteger(pk.extraSavingCents)&&pk.extraSavingCents>0?pk.extraSavingCents:0;
    if(refNote)card.append(refHintNode(refNote));
    refOffer(refNote?d.referral.ratePercent:null,refNow?.displayName||'');
    // Claude-61: the service chose Black Friday (no codes): one line, the reward lines are not shown.
    // Claude-66: with "Black Friday 25% messaging" off, no Black Friday line (the service's choice stands).
    const bf=flags.messaging?d.blackFriday:null,bfRewards=bf?.package==='rewards'&&d.items.length>0;
    if(bf?.package==='blackFriday'){
     rewardCents=0;
     const ul=el('ul','fd-rw-cart__lines'),li=el('li','fd-rw-cart__line fd-rw-cart__line--bf');
     li.append(el('span','',TEXT.bfLine),el('span','fd-rw-cart__amount','−'+money(bf.savingCents)));ul.append(li);
     const total=el('p','fd-rw-cart__total',TEXT.bfApplied);total.setAttribute('role','status');
     card.append(ul,total,el('p','fd-rw-cart__note',TEXT.bfWallet));
    }else if(d.items.length||refSave){
     const ul=el('ul','fd-rw-cart__lines');
     for(const item of d.items){const li=el('li','fd-rw-cart__line');li.append(el('span','',nameOf(module,item.type)),el('span','fd-rw-cart__amount','−'+money(item.savingCents)));ul.append(li);}
     if(refSave){const li=el('li','fd-rw-cart__line fd-rw-cart__line--ref');li.append(el('span','',TEXT.refLine(refNow?.displayName||'',d.referral.ratePercent-10)),el('span','fd-rw-cart__amount','−'+money(refSave)));ul.append(li);}
     // Owner 10-25: the lines add up to more than the total when the rewards cost the free shipping.
     shippingCents=shippingAddedCents(d.items,d.totalSavingCents);
     if(refSave)shippingCents=shippingAddedCents([...d.items,{savingCents:refSave}],d.totalSavingCents);
     if(shippingCents>0){
      shippingRow=el('li','fd-rw-cart__line fd-rw-cart__line--shipping');
      shippingRow.append(el('span','',TEXT.shipping),el('span','fd-rw-cart__amount',TEXT.shippingAmount(money(shippingCents))));
      ul.append(shippingRow);
     }
     card.append(ul);
     // Claude-61: in Black Friday the cart subtotal shows the 25% price, so the rewards package
     // states its own price instead of a saving against the 10% price.
     const total=el('p','fd-rw-cart__total',bfRewards&&d.afterDiscountsCents!==null?TEXT.bfRewardsPrice(money(d.afterDiscountsCents)):TEXT.savings(money(d.totalSavingCents)));total.setAttribute('role','status');
     card.append(total,el('p','fd-rw-cart__note',bfRewards?TEXT.bfRewards:TEXT.auto));
     if(d.maskedEmail)card.append(el('p','fd-rw-cart__note',TEXT.email(d.maskedEmail)));
    }else card.append(el('p','fd-rw-cart__note',TEXT.none));
    if(d.voucherReauthRequired&&d.items.some(i=>i.type==='reward100'||i.type==='reward500'))card.append(el('p','fd-rw-cart__note',TEXT.voucherVerify));
    if(d.next){gap=d.next.missingCents;card.append(el('p','fd-rw-cart__next',TEXT.next(money(d.next.missingCents),lowerFirst(nameOf(module,d.next.type)),roughMoney(d.next.estimatedSavingCents))));}
    if(d.freeSpins>0){
     card.append(el('p','fd-rw-cart__note',TEXT.spins(d.freeSpins)));
     const b=button('fd-rw-cart__button',TEXT.spin,()=>openCard('auto',b));card.append(b);
    }
   }
  }
  // Claude-56: no shipping line or add-ons until the guard has confirmed the custom price either.
  if(prices!=='ready'){mount(card);return;}
  // The service's own after-discount amount and threshold when it sent them (contract v1 2.).
  const served=preview.state==='ready'&&preview.key===String(subtotal)?preview.data:null;
  const line=panelShippingLine(served,cfg.blackFriday,Date.now(),flags);
  const after=served&&served.afterDiscountsCents!==null?served.afterDiscountsCents:usd?afterDiscountsOf(cart,addOnCents,rewardCents,floorPercentOf(cart,cfg.blackFriday,Date.now(),refInfo())):null;
  if(after!==null)card.append(el('p','fd-rw-cart__ship',after>=line?TEXT.shipFree(line):TEXT.shipMore(money(line-after),line)));
  // The free-shipping rule is said once: the line above already says it when the order is under
  // the line; otherwise (no after-discount amount, or it says free shipping) a small note goes
  // right under the shipping row.
  if(shippingRow&&(after===null||after>=line)){const note=el('p','fd-rw-cart__note fd-rw-cart__ship-rule',TEXT.shipRule(line));shippingRow.parentElement.after(note);}
  if(!gap&&after!==null&&after<line)gap=line-after;
  mount(card);
  if(usd&&gap>0){
   const [list,linkList]=await Promise.all([addOns(),links(cart)]);
   if(seq!==renderSeq)return;
   renderAddOns(card,list,linkList,gap,cart);
  }
 }
 function mount(card){
  if(!panel)return;
  // Keep focus on a button that is redrawn (same text) so keyboard users do not lose their place.
  const focused=panel.contains(document.activeElement)?document.activeElement.textContent:'';
  panel.replaceChildren(card);panel.dataset.state='ready';
  if(focused){const again=[...card.querySelectorAll('button')].find(b=>b.textContent===focused);again?.focus({preventScroll:true});}
 }

 // ---- Header mini cart: one compact line above its buttons ----
 const miniContent=document.querySelector('[data-fd-mini-cart-content]');
 async function renderMini(){
  if(!miniContent)return;
  const actions=miniContent.querySelector('.fd-header-panel__actions');
  if(!actions)return;
  let line=miniContent.querySelector('[data-fd-rw-mini]');
  if(!line){line=el('div','fd-rw-mini');line.dataset.fdRwMini='';actions.before(line);}
  const fill=nodes=>{if(line.isConnected)line.replaceChildren(...nodes);};
  if(!hasToken()){
   const b=button('fd-rw-mini__button',TEXT.verify,()=>openCard('entry',b));
   fill([el('p','fd-rw-mini__text',TEXT.unverified),b]);return;
  }
  fill([el('p','fd-rw-mini__text',TEXT.miniAuto)]);
  const cart=window.__fdCartSnapshot&&typeof window.__fdCartSnapshot==='object'?window.__fdCartSnapshot:lastCart;
  if(!cart||String(cart.currency||'USD').toUpperCase()!=='USD')return;
  const subtotal=subtotalOf(cart,confirmedAddOns());
  if(subtotal===null||priceState()!=='ready')return;
  const result=await getPreview(subtotal);
  if(result.state!=='ready')return;
  // Claude-61: Black Friday chosen, or the rewards package stated as its own price.
  const d=result.data,bf=flags.messaging?d.blackFriday:null;
  if(bf?.package==='blackFriday')fill([el('p','fd-rw-mini__text',TEXT.miniBf(money(bf.savingCents)))]);
  else if(bf?.package==='rewards'&&d.items.length&&d.afterDiscountsCents!==null)fill([el('p','fd-rw-mini__text',TEXT.miniBfRewards(money(d.afterDiscountsCents)))]);
  else if(d.totalSavingCents>0)fill([el('p','fd-rw-mini__text',TEXT.miniSavings(money(d.totalSavingCents)))]);
 }
 if(miniContent&&!designMode){
  let queued=false;
  new MutationObserver(()=>{if(queued)return;queued=true;queueMicrotask(()=>{queued=false;if(!miniContent.querySelector('[data-fd-rw-mini]'))void renderMini();});}).observe(miniContent,{childList:true});
  void renderMini();
 }

 // ---- Refresh after cart changes ----
 let refreshTimer=null,lastRefresh=0;
 async function refresh(cart){
  lastRefresh=Date.now();
  if(!panel)return;
  const fresh=cart&&Array.isArray(cart.items)?cart:await getCart();
  if(!fresh)return;
  lastCart=fresh;
  if(!fresh.item_count)return;
  await renderPanel(fresh);
 }
 const soon=(cart,ms=300)=>{clearTimeout(refreshTimer);refreshTimer=setTimeout(()=>{refreshTimer=null;void refresh(cart);},ms);};
 // rv57: a guard state change only redraws; a refresh already queued (maybe with a newer cart) is kept.
 const redraw=()=>{if(refreshTimer)return;refreshTimer=setTimeout(()=>{refreshTimer=null;void refresh(lastCart);},100);};
 if(!designMode){
  document.addEventListener('cart:updated',event=>soon(event.detail?.cart));
  document.addEventListener('fd-rewards:summary',()=>{preview={key:'',at:0,state:'idle',data:null,run:null};soon(lastCart);const old=miniContent?.querySelector('[data-fd-rw-mini]');old?.remove();void renderMini();});
  addEventListener('storage',event=>{if(event.key===null||String(event.key).startsWith('fd_rewards_'))soon(lastCart);});
  const stale=()=>{if(Date.now()-lastRefresh>3000)soon(null,50);};
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')stale();});
  addEventListener('focus',stale);
  // The checkout guard confirms custom-option add-ons later than the first paint: redraw then.
  // Claude-56: on every change of its state (checking, confirmed, could not confirm), and when the
  // page-wide flag the mini cart reads changes.
  const priced=document.querySelector('[data-fd-cart-page][data-fd-price-state-guard]');
  if(priced)new MutationObserver(records=>{if(records.some(r=>r.oldValue!==priced.dataset.fdPriceState))redraw();})
   .observe(priced,{attributes:true,attributeFilter:['data-fd-price-state'],attributeOldValue:true});
  new MutationObserver(records=>{
   const now=document.documentElement.dataset.fdConfiguredCartValid;
   if(!records.some(r=>r.oldValue!==now))return;
   redraw();
   if(miniContent){miniContent.querySelector('[data-fd-rw-mini]')?.remove();void renderMini();}
  }).observe(document.documentElement,{attributes:true,attributeFilter:['data-fd-configured-cart-valid'],attributeOldValue:true});
  if(panel)void refresh();
 }

 // ---- Checkout: codes into the cart first, then the theme's own checkout guard ----
 let flight=null,bypass=false;
 const isCartForm=form=>{try{return !!form&&form.matches('form')&&/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(new URL(form.action||'/cart',location.origin).pathname);}catch(e){return false;}};
 const isCheckoutHref=href=>{try{const u=new URL(String(href||''),location.origin);return u.origin===location.origin&&/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout\/?$/i.test(u.pathname.replace(/\/+/g,'/'));}catch(e){return false;}};
 function checkoutContext(target){
  const control=target?.closest?.('[name="checkout"], a[href]');
  if(!control)return null;
  if(control.getAttribute('name')==='checkout'){const form=control.form||control.closest('form');return isCartForm(form)?{control,form}:null;}
  return isCheckoutHref(control.getAttribute('href'))?{control,form:null}:null;
 }
 // Only when the guard itself would go ahead now; otherwise the click is left to the guard
 // untouched, so its own messages (price not confirmed, terms, required fields) appear.
 function guardReady({control,form}){
  if(control.disabled||control.hasAttribute('data-fd-checkout-guarded')||control.getAttribute('aria-busy')==='true'||control.getAttribute('aria-disabled')==='true')return false;
  const priced=control.closest('[data-fd-price-state-guard]');
  if(priced&&priced.dataset.fdPriceState!=='ready')return false;
  if(window.__fdCartCoordinator?.locked)return false;
  if(form&&typeof form.checkValidity==='function'&&!form.checkValidity())return false;
  for(const box of document.querySelectorAll('#cart_agree, #agree, #CartTerms, #torden-terms-checkbox, .rterms-checkbox'))
   if(box.type==='checkbox'&&!box.disabled&&box.getClientRects().length&&!box.checked)return false;
  return true;
 }
 function onClick(event){
  if(bypass||designMode)return;
  if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  const context=checkoutContext(event.target);
  if(!context)return;
  if(flight){event.preventDefault();event.stopImmediatePropagation();return;}
  // Claude-71: no card session but a referral: the attribute and the extra code go in first.
  if(!hasToken()&&refToken()&&guardReady(context)&&!guardCheckoutPending(()=>window.sessionStorage,document.documentElement)){
   event.preventDefault();event.stopImmediatePropagation();flight=withReferral(context).finally(()=>{flight=null;});return;
  }
  if(!hasToken()||!guardReady(context))return;
  if(guardCheckoutPending(()=>window.sessionStorage,document.documentElement))return;
  event.preventDefault();event.stopImmediatePropagation();
  flight=withRewards(context).finally(()=>{flight=null;});
 }
 // Review Claude-53 P3-3: a control with only text gets "Applying your rewards…" as its text;
 // one with icons or other elements keeps them untouched and gets a short note beside it.
 function busyLook(control){
  const plain=/^(BUTTON|A)$/.test(control.tagName)&&[...control.childNodes].every(n=>n.nodeType===3);
  const text=plain?control.textContent:null;
  control.setAttribute('aria-busy','true');
  let note=null;
  if(plain)control.textContent=TEXT.applying;
  else{note=el('span','fd-rw-cart__busy-note',TEXT.applying);note.setAttribute('role','status');control.after(note);}
  panel?.querySelectorAll('button').forEach(b=>{b.dataset.fdRwWasDisabled=b.disabled?'1':'';b.disabled=true;});
  return ()=>{
   control.removeAttribute('aria-busy');if(plain)control.textContent=text;note?.remove();
   panel?.querySelectorAll('button').forEach(b=>{b.disabled=b.dataset.fdRwWasDisabled==='1';delete b.dataset.fdRwWasDisabled;});
  };
 }
 async function putCodes(cart,codes,timeoutMs,ref=null){
  const existing=(Array.isArray(cart.discount_codes)?cart.discount_codes:[]).map(d=>String(d?.code||'')).filter(Boolean);
  const next=mergeCodes(existing,codes);
  const codesChange=!sameCodes(next,existing)&&(codes.length>0||existing.some(c=>/^FDR-/i.test(c)));
  // Claude-54: the ref goes with the codes (an older one is cleared: Shopify drops an empty attribute).
  const had=typeof cart.attributes?.[REF_ATTRIBUTE]==='string'?cart.attributes[REF_ATTRIBUTE]:'',want=ref||'';
  const refChange=had!==want;
  // Claude-71: the referral token as the cart attribute _fd_ref, in the same update (or alone).
  const fdRef=refToken(),fdRefChange=!!fdRef&&cart.attributes?.[REF_CART_ATTRIBUTE]!==fdRef;
  if(!codesChange&&!refChange&&fdRefChange)return !!await cartRequest('cart/update.js',{method:'POST',body:{attributes:{[REF_CART_ATTRIBUTE]:fdRef}},timeoutMs});
  if(!codesChange&&!refChange)return true;
  const body={...(codesChange?{discount:next.join(',')}:{}),...(refChange?{attributes:{[REF_ATTRIBUTE]:want}}:{})};
  if(fdRefChange)body.attributes={...(body.attributes||{}),[REF_CART_ATTRIBUTE]:fdRef};
  return !!await cartRequest('cart/update.js',{method:'POST',body,timeoutMs});
 }
 // ---- Claude-54: VO Product Options draft checkout ----
 // Armed by a checkout that put codes and a ref in the cart; used by the next VO draft request
 // only (one shot), for at most VO_ARM_MS.
 let voArm=null,voWaiting=false;
 const takeVoArm=()=>{const arm=voArm;voArm=null;return arm&&Date.now()<=arm.until?arm:null;};
 async function attachDraft(ref,invoiceToken){
  // Claude-71: armed for the referral only (no card session, or no reward codes): store/ref/attach.
  if(ref&&typeof ref==='object')return attachReferral(ref.referral,invoiceToken);
  if(!ref||!invoiceToken)return 'skipped';
  try{
   const m=await timeout(loadPopup(),ATTACH_BUDGET_MS);
   if(typeof m.cartAttach!=='function')return 'skipped';
   return await timeout(m.cartAttach(ref,invoiceToken,{timeout:ATTACH_BUDGET_MS}),ATTACH_BUDGET_MS);
  }catch(e){return 'failed';}
 }
 function armVo(ref){
  voArm={ref,until:Date.now()+VO_ARM_MS};
  // VO loads its jQuery itself (bcpo.$); the guard waits up to 8 s for it, so wait a bit longer.
  if(wrapVoAjax(window.bcpo?.$,{take:takeVoArm,attach:attachDraft})||voWaiting)return;
  voWaiting=true;
  const until=Date.now()+VO_WAIT_MS;
  const poll=()=>{
   if(wrapVoAjax(window.bcpo?.$,{take:takeVoArm,attach:attachDraft})||Date.now()>until){voWaiting=false;return;}
   setTimeout(poll,100);
  };
  setTimeout(poll,100);
 }
 async function withRewards(context){
  context.control.parentElement?.querySelector(':scope > .fd-rw-cart__tap-again')?.remove();
  let restore=busyLook(context.control);
  // One deadline for cart read + apply + cart update (about 8 s); a re-verify in the card
  // (the customer typing a code) is not counted, and the retry after it gets a new budget.
  let deadline=Date.now()+APPLY_BUDGET_MS;
  const left=()=>deadline-Date.now();
  try{
   const cart=await getCart({timeoutMs:left()});
   if(cart&&cart.item_count>0&&String(cart.currency||'USD').toUpperCase()==='USD'&&left()>200){
    const subtotal=subtotalOf(cart,confirmedAddOns());
    let codes=null;
    refKnownCodes=refCodesKnown();
    try{codes=await timeout(loadPopup().then(m=>m.cartApplyRef(subtotal,{timeout:Math.max(1,left())})),Math.max(1,left()));}
    catch(e){
     if(e?.kind==='REAUTH'){
      // Re-verify in the card, then try once more; closing the card means "check out without".
      restore();restore=null;
      const m=await loadPopup().catch(()=>null);
      const ok=m?await m.signInForCart(context.control,e.reason||''):false;
      restore=busyLook(context.control);
      deadline=Date.now()+APPLY_BUDGET_MS;
      if(ok)codes=await timeout(m.cartApplyRef(subtotal,{timeout:left()}),left()).catch(()=>null);
     }
    }
    if(codes&&Array.isArray(codes.codes)&&left()>200){
     const put=await timeout(putCodes(cart,codes.codes,left(),codes.ref),Math.max(1,left())).catch(()=>false);
     if(put&&codes.ref&&codes.codes.length)armVo(codes.ref);
     // Claude-71: no reward codes for this draft (for example Black Friday saves more): referral only.
     else if(put&&refToken())armVo({referral:refToken()});
    }
   }
  }catch(e){}
  finally{restore?.();}
  // Claude-71: the rewards step did not reach the cart (failed, slow, no codes): the referral attribute
  // still goes in before checkout (a short budget of its own), and a VO draft gets store/ref/attach.
  // Claude-76 (review P3-8): the friend's extra code goes in too, card session or not, so the friend
  // still gets the referrer's rate (Black Friday still keeps it out).
  if(!voArm&&refToken()){try{await timeout(refCart({withCode:true,sessionCode:true,budgetMs:REF_CHECKOUT_BUDGET_MS}),REF_CHECKOUT_BUDGET_MS);}catch(e){}if(refToken())armVo({referral:refToken()});}
  await handBack(context);
 }
 // The same control is clicked again with this module stepping aside, so the theme's checkout
 // guard validates the (now discounted) cart and opens checkout exactly as before.
 async function handBack({control}){
  if(!control.isConnected)return;
  for(const until=Date.now()+ENABLE_WAIT_MS;control.disabled&&Date.now()<until;)await sleep(100);
  // Review Claude-53 P3-2: the theme kept the button disabled; the codes are in the cart, so
  // one more tap goes straight on. Say so next to the button instead of doing nothing.
  if(control.disabled){
   if(!control.parentElement?.querySelector(':scope > .fd-rw-cart__tap-again')){
    const note=el('p','fd-rw-cart__tap-again',TEXT.tapAgain);note.setAttribute('role','status');control.after(note);
   }
   return;
  }
  bypass=true;
  try{control.click();}finally{bypass=false;}
 }
 // ---- Claude-71: referral link capture (contract 一.1–3, 2.1, 2.2) ----
 // Token in the cookie only (plus this page's memory when cookies are refused); the code-free details
 // ({alias, displayName, ratePercent, extraCode}) in localStorage for the hint and the extra code.
 const REF_CHECKOUT_BUDGET_MS=3000;
 let refMem={token:null,info:null},refPendingMem=null;
 const readLocal=key=>{try{return JSON.parse(window.localStorage.getItem(key)||'null');}catch(e){return null;}};
 const writeLocal=(key,value)=>{try{if(value===null)window.localStorage.removeItem(key);else window.localStorage.setItem(key,JSON.stringify(value));}catch(e){}};
 function refToken(){let t=null;try{t=readRefCookie(document.cookie);}catch(e){}return t||(refTokenOk(refMem.token)?refMem.token:null);}
 function refInfo(){
  const alias=refAliasOfToken(refToken());if(!alias)return null;
  const i=readLocal(REF_INFO_KEY)||refMem.info;
  return i&&i.v===1&&i.alias===alias&&Number.isInteger(i.ratePercent)?i:null;
 }
 function refCodesKnown(){const i=readLocal(REF_INFO_KEY)||refMem.info;return i&&i.v===1?[i.extraCode,...(Array.isArray(i.dropCodes)?i.dropCodes:[])].filter(isRefCode).slice(0,4):[];}
 // Claude-83 (review P3-3): a pending alias gets at most REF_PENDING_TRIES opens (the landing one included) within
 // REF_PENDING_MAX_MS of the click; after that it is dropped silently. JSON NOT_FOUND (off) still drops it at once.
 const REF_PENDING_TRIES=3,REF_PENDING_MAX_MS=86400000;
 function pendingAlias(){
  const p=readLocal(REF_PENDING_KEY)||refPendingMem;
  const ok=p&&typeof p.alias==='string'&&REF_ALIAS_RE.test(p.alias)&&Number.isFinite(p.at)&&Date.now()-p.at<REF_PENDING_MAX_MS&&!(Number.isInteger(p.tries)&&p.tries>=REF_PENDING_TRIES);
  if(!ok&&p)setPending(null);
  return ok?p.alias:null;
 }
 function setPending(value){refPendingMem=value;writeLocal(REF_PENDING_KEY,value);}
 // Product-page dynamic checkout buttons (Shop Pay, Apple Pay "Buy it now") skip the cart and so the
 // attribute: hidden while a confirmed referral token (fd_ref) is held. An alias still being opened
 // (cold start, retried on the next page) does not hide them (Claude-76, review P3-7). Cart-page buttons stay.
 function markRef(){try{document.documentElement.classList.toggle('fd-ref-on',!!refToken());}catch(e){}}
 function refStyle(){
  try{if(document.getElementById('fd-ref-style'))return;const st=document.createElement('style');st.id='fd-ref-style';
   st.textContent='html.fd-ref-on .shopify-payment-button,html.fd-ref-on shopify-accelerated-checkout{display:none!important}';
   (document.head||document.documentElement).append(st);}catch(e){}
 }
 function saveRef(token,info){
  const old=readLocal(REF_INFO_KEY)||refMem.info;
  const dropped=old&&old.v===1&&isRefCode(old.extraCode)&&String(old.extraCode).toUpperCase()!==String(info.extraCode||'').toUpperCase()?[old.extraCode]:[];
  const dropCodes=[...dropped,...(Array.isArray(old?.dropCodes)?old.dropCodes:[])].filter(c=>isRefCode(c)&&String(c).toUpperCase()!==String(info.extraCode||'').toUpperCase()).slice(0,3);
  const next={...info,dropCodes};
  refMem={token,info:next};
  try{document.cookie=refCookieString(token,location.protocol==='https:');}catch(e){}
  writeLocal(REF_INFO_KEY,next);
 }
 async function refPost(path,body,ms){
  const controller=typeof AbortController==='function'?new AbortController():null;
  const timer=controller?setTimeout(()=>controller.abort(),ms):null;
  try{
   const r=await fetch(path,{method:'POST',cache:'no-store',credentials:'omit',redirect:'error',referrerPolicy:'no-referrer',
    headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify(body),signal:controller?.signal});
   let data=null;try{data=await r.json();}catch(e){}
   return {status:r.status,body:data};
  }catch(e){return {status:0,body:null};}
  finally{if(timer)clearTimeout(timer);}
 }
 // fresh: the alias came from this page's address (a new click). Kept as pending first, so a page
 // left before the answer still tries again on the next page view.
 async function openRef(alias,fresh){
  // Claude-83: the attempt is counted before the request (a page left mid-request still used one).
  const prev=fresh?null:readLocal(REF_PENDING_KEY)||refPendingMem;
  const tries=(prev&&prev.alias===alias&&Number.isInteger(prev.tries)&&prev.tries>0?prev.tries:0)+1;
  setPending({alias,at:prev&&Number.isFinite(prev.at)?prev.at:Date.now(),tries});
  const answer=await refPost(REF_OPEN_PATH,{alias},REF_OPEN_TIMEOUT_MS);
  const result=parseRefOpen(answer.status,answer.body);
  if(result.kind!=='retry'||tries>=REF_PENDING_TRIES)setPending(null);
  if(result.kind==='ready')saveRef(result.token,result.info);
  markRef();
  return result;
 }
 // The referral into this cart: attribute _fd_ref always; the extra code (withCode) only for a friend
 // without a card session, outside Black Friday, at landing and before checkout. sessionCode: also
 // with a card session (the session's own store/cart/apply did not reach the cart). Never while the
 // checkout guard is recovering a custom checkout (the cart attributes must not change then).
 async function refCart({cart=null,withCode=false,sessionCode=false,fresh=false,budgetMs=CART_TIMEOUT_MS}={}){
  const token=refToken();if(!token)return false;
  if(guardCheckoutPending(()=>window.sessionStorage,document.documentElement))return false;
  const until=Date.now()+budgetMs,left=()=>Math.max(1,until-Date.now());
  const current=cart&&Array.isArray(cart.items)?cart:await getCart({timeoutMs:left()});if(!current)return false;
  const info=refInfo(),bf=blackFridayOn(cfg.blackFriday,Date.now())||(fresh&&info?.blackFridayActive===true);
  const patch=refCartPatch(current,{token,info,withCode:withCode&&(sessionCode||!hasToken())&&!bf});
  if(!patch)return true;
  const updated=await cartRequest('cart/update.js',{method:'POST',body:patch,timeoutMs:left()});
  if(updated&&panel&&!flight)soon(updated,50);
  return !!updated;
 }
 async function attachReferral(token,invoiceToken){
  if(!refTokenOk(token)||typeof invoiceToken!=='string'||!/^[A-Za-z0-9]{16,64}$/.test(invoiceToken))return 'skipped';
  const answer=await refPost(REF_ATTACH_PATH,{token,invoiceToken},REF_ATTACH_TIMEOUT_MS);
  return answer.status===200&&answer.body?.schemaVersion===1&&typeof answer.body.status==='string'&&/^[a-z_]{2,32}$/.test(answer.body.status)?answer.body.status:'failed';
 }
 // Checkout without a card session: attribute + extra code (about 3 s at most), VO armed for
 // store/ref/attach, then the same click goes on to the guard. A failure never stops checkout.
 async function withReferral(context){
  try{await timeout(refCart({withCode:true,budgetMs:REF_CHECKOUT_BUDGET_MS}),REF_CHECKOUT_BUDGET_MS);}catch(e){}
  if(refToken())armVo({referral:refToken()});
  await handBack(context);
 }
 function refHintNode(text){const p=el('p','fd-rw-cart__note fd-rw-cart__ref',text);p.dataset.fdRwRef='';return p;}
 // Owner test 10-27: the cart summary headline ("10% OFF Your Order") shows the friend's rate while the
 // friend hint would show; otherwise the theme's own text comes back.
 function refOffer(rate,name){
  try{
   const box=document.querySelector('.fd-cart-summary__offer[data-fd-bf-copy="normal"]');
   const strong=box?.querySelector('strong'),note=box?.querySelector('span');if(!strong||!note)return;
   if(!offerBase)offerBase={strong:strong.textContent,note:note.textContent};
   const on=Number.isInteger(rate)&&rate>10&&rate<=15;
   strong.textContent=on?TEXT.refOffer(rate):offerBase.strong;
   note.textContent=on?TEXT.refOfferNote(name):offerBase.note;
  }catch(e){}
 }
 // Claude-83 (review P3-2): ?fdr leaves the address bar once read (as the launcher does with fd_rewards), so a
 // reload or a forwarded address does not open the same click again; a retry goes through the pending alias.
 function dropFdr(){try{const url=new URL(location.href);if(!url.searchParams.has('fdr'))return;url.searchParams.delete('fdr');window.history.replaceState(window.history.state,'',url.pathname+url.search+url.hash);}catch(e){}}
 async function syncRef(){
  const alias=refAliasOf(location.search);
  if(alias!==null)dropFdr();
  let opened=null;
  if(alias)opened=await openRef(alias,true);
  else{const p=pendingAlias();if(p)opened=await openRef(p,false);}
  if(!refToken())return;
  await refCart({withCode:opened?.kind==='ready',fresh:opened?.kind==='ready'});
 }
 if(!designMode){
  try{
   refStyle();markRef();
   // Never blocks the page: after the DOM is parsed (this script is defer), in the background.
   void syncRef().catch(()=>{}).finally(markRef);
   // A cart change (theme event with the new cart) that lost the attribute gets it again.
   document.addEventListener('cart:updated',event=>{const c=event.detail?.cart,t=refToken();
    if(t&&c&&Array.isArray(c.items)&&c.attributes&&c.attributes[REF_CART_ATTRIBUTE]!==t)void refCart({cart:c}).catch(()=>{});});
  }catch(e){}
 }
 if(window.__FD_RW_CART_TEST__===true)Object.assign(window.__fdRwCartTest,{refToken,refInfo,pendingAlias,openRef,refCart,attachReferral,syncRef,dropFdr,REF_PENDING_TRIES,REF_PENDING_MAX_MS,
  voArm:()=>voArm});
 const hook=window.__fdRwCartHook;
 if(hook&&typeof hook==='object')hook.handle=onClick;
 else addEventListener('click',onClick,true);
 if(window.__FD_RW_CART_TEST__===true)Object.assign(window.__fdRwCartTest,{refresh,renderMini,checkoutContext,guardReady,getPreview,
  voArmed:()=>!!voArm,priceState});
})();
